(() => {
  const attributionPattern = /^Purchased from (Shopee|TikTok) (MY|SG)$/i;
  const reviewParagraphSelector = [
    '.jdgm-review-card__body > p',
    '.jdgm-rev__body > p',
  ].join(',');

  function removeMarketplaceAttributions(root = document) {
    root.querySelectorAll(reviewParagraphSelector).forEach((paragraph) => {
      if (attributionPattern.test(paragraph.textContent.trim())) {
        paragraph.remove();
      }
    });
  }

  let cleanupQueued = false;
  function queueCleanup() {
    if (cleanupQueued) return;
    cleanupQueued = true;
    requestAnimationFrame(() => {
      cleanupQueued = false;
      removeMarketplaceAttributions();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueCleanup, { once: true });
  } else {
    queueCleanup();
  }

  new MutationObserver(queueCleanup).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
